routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.templateDetail', {
      url: "/plantillas/detalle/{templateId}",
      template: `<template-detail sh-ctrl="shCtrl"></template-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/templates/template-detail/template-detail.config.js
 **/